module.exports = __webpack_public_path__ + "static/media/supernode.9ac92427.png";